module.exports = __webpack_public_path__ + "static/media/d-avatar.fa75c225.jpg";